module.exports = __webpack_public_path__ + "img/del.a7ea0727.svg";